var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9433 0 0 17.9433 0 40C0 62.0567 17.9433 80 40 80C62.0567 80 80 62.0567 80 40C80 17.9433 62.0567 0 40 0ZM54.68 46.2433L37.3067 55.7567C36.2233 56.3667 35.03 56.67 33.8367 56.67C32.5933 56.67 31.3467 56.34 30.2133 55.68C27.99 54.38 26.6667 52.07 26.6667 49.4967V30.5C26.6667 27.9267 27.99 25.6167 30.2133 24.3167C32.43 23.02 35.0967 22.9967 37.34 24.26L54.6467 33.7367C56.9667 35.04 58.33 37.3733 58.33 39.9967C58.33 42.62 56.9667 44.9533 54.6767 46.24L54.68 46.2433ZM51.6667 40C51.6667 40.29 51.4733 40.3967 51.4467 40.4167L34.0733 49.9333C34.01 49.9667 33.8167 50.0733 33.5833 49.93C33.3367 49.7867 33.3367 49.5733 33.3367 49.5033V30.5067C33.3367 30.4367 33.3367 30.2233 33.5833 30.08C33.6733 30.0267 33.7567 30.01 33.83 30.01C33.95 30.01 34.0467 30.0633 34.1067 30.0967L51.4133 39.5767C51.4767 39.6133 51.6667 39.72 51.6667 40.01V40Z",
    fill: "#55217E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.231d00f2.svg";
export { ForwardRef as ReactComponent };